import { useMutation, type UseMutationResult } from '@tanstack/react-query';
import {
  addQuestionToLiveStreamRequest,
  type LiveStreamRequest,
} from 'services/liveStreamRequests';

interface AddQuestionVariables {
  id: string;
  question: string;
}

const useAddLiveStreamRequestQuestion = (): UseMutationResult<
  LiveStreamRequest,
  unknown,
  AddQuestionVariables
> =>
  useMutation({
    mutationFn: ({ id, question }: AddQuestionVariables) =>
      addQuestionToLiveStreamRequest(id, question),
    retry: false,
  });

export default useAddLiveStreamRequestQuestion;
